<template>
  <a-drawer width="70%" :label-col="4" :wrapper-col="14" :visible="open"  @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>支付单状态</b>
    </a-divider>
    <div class="order-info">
      <table>
        <tr>
          <td style="vertical-align: top;background-color:#fbfbfb;">
            <a-card  :bordered="false" title="状态"
                    :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
                    :bodyStyle="{'background-color':'#fbfbfb'}">
              <table class="info-table">
                <tr>
                  <td class="second">错误代码：</td>
                  <td class="secondData">{{ record.errCode }}</td>
                  <td class="second">错误说明：</td>
                  <td class="secondData">{{ record.errMsg }}</td>
                </tr>
                <tr>
                  <td class="second">支付时间：</td>
                  <td class="secondData">{{ record.payTime }}</td>
                  <td class="second">商户号：</td>
                  <td class="secondData">{{ record.mid }}</td>
                </tr>
                <tr>
                  <td class="second">终端号：</td>
                  <td class="secondData">{{ record.tid }}</td>
                  <td class="second">业务类型：</td>
                  <td class="secondData">{{ record.instMid }}</td>
                </tr>
                <tr>
                  <td class="second">附加数据：</td>
                  <td class="secondData" colspan="3">{{ record.attachedData }}</td>
                </tr>
                <tr>
                  <td class="second">支付银行信息：</td>
                  <td class="secondData">{{ record.bankCardNo }}</td>
                  <td class="second">银行信息：</td>
                  <td class="secondData">{{ record.bankInfo }}</td>
                </tr>
                <tr>
                  <td class="second">资金渠道：</td>
                  <td class="secondData">{{ record.billFunds }}</td>
                  <td class="second">资金渠道说明：</td>
                  <td class="secondData">{{ record.billFundsDesc }}</td>
                </tr>
                <tr>
                  <td class="second">买家 ID：</td>
                  <td class="secondData">{{ record.buyerId }}</td>
                  <td class="second">买家用户名：</td>
                  <td class="secondData">{{ record.buyerUsername }}</td>
                </tr>
                <tr>
                  <td class="second">买家子 ID：</td>
                  <td class="secondData">{{ record.subBuyerId }}</td>
                  <td class="second">交易状态：</td>
                  <td class="secondData">{{ record.status }}</td>
                </tr>
                <tr>
                  <td class="second">实付金额（分）：</td>
                  <td class="secondData">{{ record.buyerPayAmount }}</td>
                  <td class="second">订单金额（分）：</td>
                  <td class="secondData">{{ record.totalAmount }}</td>
                </tr>
                <tr>
                  <td class="second">开票金额（分）：</td>
                  <td class="secondData">{{ record.invoiceAmount }}</td>
                  <td class="second">实收金额（分）：</td>
                  <td class="secondData">{{ record.receiptAmount }}</td>
                </tr>
                <tr>
                  <td class="second">商户订单号：</td>
                  <td class="secondData">{{ record.merOrderId }}</td>
                  <td class="second">支付银行卡参考号：</td>
                  <td class="secondData">{{ record.refId }}</td>
                </tr>
                <tr>
                  <td class="second">退款金额（分）：</td>
                  <td class="secondData">{{ record.refundAmount }}</td>
                  <td class="second">退款说明：</td>
                  <td class="secondData">{{ record.refundDesc }}</td>
                </tr>
                <tr>
                  <td class="second">系统交易流水号：</td>
                  <td class="secondData">{{ record.seqId }}</td>
                  <td class="second">结算日期：</td>
                  <td class="secondData">{{ record.settleDate }}</td>
                </tr>
                <tr>
                  <td class="second">渠道订单号：</td>
                  <td class="secondData">{{ record.targetOrderId }}</td>
                  <td class="second">支付渠道：</td>
                  <td class="secondData">{{ record.targetSys }}</td>
                </tr>
                <tr>
                  <td class="second">商户出资优惠金额（分）：</td>
                  <td class="secondData">{{ record.couponMerchantContribute }}</td>
                  <td class="second">其他出资优惠金额（分）：</td>
                  <td class="secondData">{{ record.couponOtherContribute }}</td>
                </tr>
                <tr>
                  <td class="second">渠道优惠金额（分）：</td>
                  <td class="secondData">{{ record.couponAmount }}</td>
                  <td class="second">微信活动 ID：</td>
                  <td class="secondData">{{ record.activityIds }}</td>
                </tr>
                <tr>
                  <td class="second">退货渠道订单号：</td>
                  <td class="secondData">{{ record.refundTargetOrderId }}</td>
                  <td class="second">退货时间：</td>
                  <td class="secondData">{{ record.refundPayTime }}</td>
                </tr>
                <tr>
                  <td class="second">退货结算日期：</td>
                  <td class="secondData">{{ record.refundSettleDate }}</td>
                  <td class="second">退货外部订单号：</td>
                  <td class="secondData">{{ record.refundExtOrderId }}</td>
                </tr>
                <tr>
                  <td class="second">退货订单号：</td>
                  <td class="secondData">{{ record.refundOrderId }}</td>
                  <td class="second">联盟优惠金额（分）：</td>
                  <td class="secondData">{{ record.yxlmAmount }}</td>
                </tr>
                <tr>
                  <td class="second">订单详情：</td>
                  <td class="secondData" colspan="3">{{ record.orderDesc }}</td>
                </tr>
                <tr>
                  <td class="second">订单创建时间：</td>
                  <td class="secondData">{{ record.createTime }}</td>
                  <td class="second">商户 UUID：</td>
                  <td class="secondData">{{ record.mchntUuid }}</td>
                </tr>
                <tr>
                  <td class="second">转接系统：</td>
                  <td class="secondData">{{ record.connectSys }}</td>
                  <td class="second">商户所属分支机构代码：</td>
                  <td class="secondData">{{ record.subInst }}</td>
                </tr>
                <tr>
                  <td class="second">商品交易单号：</td>
                  <td class="secondData">{{ record.goodsTradeNo }}</td>
                  <td class="second">外部订单号：</td>
                  <td class="secondData">{{ record.extOrderId }}</td>
                </tr>
                <tr>
                  <td class="second">担保交易状态：</td>
                  <td class="secondData">{{ record.secureStatus }}</td>
                  <td class="second">担保完成金额：</td>
                  <td class="secondData">{{ record.completeAmount }}</td>
                </tr>
              </table>
            </a-card>
          </td>
        </tr>
      </table>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <change-log ref="changeLogModal" />
    </div>
    <div class="bottom-control">
      <a-space>
        <a-button type="dashed" @click="cancel">
          {{$t('通用.按钮.关闭')}}
        </a-button>
      </a-space>
    </div>
  </a-drawer>
</template>

<script>
import {paymentStatus} from '@/api/finance/payment'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";


export default {
  name: 'detailForm',
  props: {
  },
  components: {
    CustomDictTag
  },
  data () {
    return {
      record: {
      } ,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      // 表单参数
      form: {
        id: null,
        outTradeNo: null,
        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        outTradeNo: null,
        remark: null,
      }
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },

    /** 修改按钮操作 */
    handleDetail(id) {
      this.reset()
      this.formType = 2
      paymentStatus({"id":id}).then(response => {
        this.record = response.data
        this.open = true
      })
    },
  }
}
</script>

<style lang="less" scoped>
.title {
  color: rgba(0, 0, 0, .85);
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
}

.message-text {
  font-family: MicrosoftYaHei;
  font-size: 1rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3rem;
  letter-spacing: 0rem;
  color: #333333;
  width: 50%;
}

.fontblack {
  color: #999999
}

.img2 {
  width: .81rem;
  height: .8rem;
  float: right;
}


.orderTitle {
  font-size: 1rem;
  color: #333333;
  height: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
  height: 2.5rem;
}

.orderDetail {
  font-size: 0.8rem;
  color: #666666;
  text-align: left;
}

.border-ceter {
  width: 92%;
  padding-left: 15px;
  padding-right: 15px;
}

.pay-button {
  width: 88%;
  height: 2.6rem;
  position: relative;
  background-color: red;
  color: white;

  margin-left: 6%;
}

ul li {
  list-style: none;
  font-size: 1rem;
}

ul {
  padding-left: 1.5rem
}

.track-rcol {
}

.track-list {
  position: relative;
}

.track-list li {
  position: relative;
  padding: 0px 0 1.5rem 25px;
  line-height: 1rem;
  border-left: 1px solid #d9d9d9;
  color: #999;
}

.track-list li.first {
  color: red;
  padding-top: 0;
  width: 100%;
  text-align: left;
  border-left: 1px solid #d9d9d9;
}

.track-list li .node-icon {
  position: absolute;
  left: -5.5px;
  border-radius: 0.25rem;
  width: 0.5rem;
  height: 0.5rem;
  top: 4px;
  background-color: #999999;
}

.track-list li.first .node-icon {
  background-position: 0-72px;
  background-color: red;
  width: 1rem;
  z-index: 2;
  height: 1rem;
  position: absolute;
  left: -9px;
  top: 0;
  border-radius: 0.5rem;
}

.track-list li .time {
  margin-right: 20px;
  position: relative;
  top: 4px;
  display: inline-block;
  vertical-align: middle;
  background-color: white;
  color: #999;
  width: 100%;
  text-align: left;
}

.track-list li .txt {
  position: relative;
  display: inline-block;
  vertical-align: top;
  color: #999;
}

.track-list li.first .time {
  text-align: left;
  width: 94%;
  color: red;
}

.track-list li.first .txt {
  color: red;
  text-align: left;
  width: 94%;
}

.track-list li.finall {
  position: relative;
  padding: 0px 0 1.5rem 25px;
  line-height: 18px;
  border-color: white;
  border-left: 1px solid #ffffff;
  color: #999;
}

.track-list li.finall .div-spilander {
  width: 1px;
  position: absolute;
  position: absolute;
  left: -1.5px;
  height: 0.5rem;
  background-color: #d9d9d9;
}

.order-info {
  border: 1px solid #e8e8e8;
  margin-top: 40px;

  .info-table {
    tr {
      height: 50px;
    }
    td {
      display: table-cell;
      vertical-align: top;
      font-size: 16px;
    }

    .first {
      width: 100px;
    }
    .second {
      width: 200px;
    }
    .secondData {
      width: 600px;
    }
    .data {
      width: 300px;
    }
  }
}

.detailPanel {
  dd, dt {
    display: inline-block;
    vertical-align: center;
  }

  dt img {
    margin: 0 20px 5px 0px;
  }

  dd {
    h3 {
      font-weight: bold;
    }
  }

  .trade-detail-prompt {
    margin-left: 35px;

    li {
      font-size: 13px !important;

      .dotted-node {
        padding: 0 5px;
      }
    }
  }
}

.order-money {
  .om-c1 {
    font-size: 14px;
    color: #666
  }

  .om-c2 {
    font-size: 16px;
    color: #333;
    font-weight: bold;
  }

  .om-c3 {
    font-size: 16px;
    color: #DE3636;
    font-weight: bold;
  }

  td {
    text-align: right;
  }

  float: right;
  margin: 20px 40px 20px 0;
}
</style>
